// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1DurationSchema } from './v1/durationSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const getEntryDurationsQueryParamsSchema = z.object({
  entry_ids: z.coerce.string().describe("Comma-separated list of entry IDs to calculate duration for"),
});

export const getEntryDurationsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entry duration calculated
 */
export const getEntryDurations200Schema = z.lazy(() => v1DurationSchema);

/**
 * @description Unauthorized
 */
export const getEntryDurations401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const getEntryDurationsQueryResponseSchema = z.lazy(() => getEntryDurations200Schema);
